<template>
    <div class="example-2 card-video cursor-pointer" @click="cardClicked">
        <div class="wrapper" :style="'background: url(' + video.kiss_video.actual_thumbnail_url + ') center / cover no-repeat;'">
            <div class="header">
                <ul class="menu-content-left">
                    <li v-if="showLike">
                        <i class="mdi mdi-36px mdi-heart shadow-sm" style="text-shadow: 0 0 3px #000;" :class="{'text-primary': isVideoFavored}"></i>
                    </li>
                </ul>
                <ul class="menu-content-right">
                    <li v-if="showCompleted">
                        <i class="mdi mdi-36px text-primary shadow-sm mdi-check-decagram" style="text-shadow: 0 0 3px #000;" v-if="watchedEntirely"></i>
                    </li>
                </ul>
            </div>
            <div class="data">
                <div class="content">
                    <span class="level">
                        <gym-video-level-badge :level="video.level" :label="video.localized_level" font-size="12px"/>
                    </span>
                    <h1 class="title">
                        <a href="#">{{ videoTitle }}</a>
                    </h1>
                    <div class="hide-area">
                        <p class="text oswald text-center">
                            {{ $t('video.desc', {intensity: video.intensity, duration: video.duration / 60}) }}
                        </p>
                        <a href="#" class="btn button btn-dark btn-sm">
                            {{ $t('video.watch_now') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GymVideoLevelBadge from "./Badges/GymVideoLevelBadge";
import GymVideoIntensityBadge from "./Badges/GymVideoIntensityBadge";
import GymVideoDurationBadge from "./Badges/GymVideoDurationBadge";
export default {
    name: "GymVideoCardNew",
    components: {GymVideoDurationBadge, GymVideoIntensityBadge, GymVideoLevelBadge},
    props: {
        video: {
            type: Object,
            required: true
        },
        showProgress: {
            type: Boolean,
            default: true
        },
        showLike: {
            type: Boolean,
            default: true
        },
        showCompleted: {
            type: Boolean,
            default: true
        },
        hoverEffectEnabled: {
            type: Boolean,
            default: true
        },
        pageLinkEnabled: {
            type: Boolean,
            default: false
        },
        thumbnailEnabled: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        hovered: false,
        imageLoaded: false
    }),
    methods: {
        cardClicked() {
            if(!this.pageLinkEnabled)
                return false;

            this.$router.push({name: 'gym.video', params: {video: this.video.id}});
        }
    },
    computed: {
        videoTitle() {
            if(this.video.title[this.$i18n.locale] === null) {
                if(this.video.title["en"] !== null)
                    return this.video.title["en"]
                else
                    return this.video.title.find(t => t !== null) || "???";
            }

            return this.video.title[this.$i18n.locale];
        },
        videoEquipment() {
            if(this.video.equipment[this.$i18n.locale] === null) {
                if(this.video.equipment["en"] !== null)
                    return this.video.equipment["en"]
                else
                    return this.video.equipment.find(t => t !== null) || "???";
            }

            return this.video.equipment[this.$i18n.locale];
        },
        kissVideoExisting() {
            return this.video.kiss_video !== undefined && this.video.kiss_video !== null;
        },
        startedWatching() {
            if(typeof this.video === 'undefined' || typeof this.video.user === 'undefined')
                return false;

            return this.video.user.playtime !== 0;
        },
        percentageWatched() {
            if(!this.startedWatching)
                return 0;

            let videoLength = this.video.length;
            let secondsWatched = this.video.user.playtime;

            return (secondsWatched / videoLength) * 100;
        },
        watchedEntirely() {
            if(!this.startedWatching)
                return false;

            return this.video.user.completed;
        },
        isVideoFavored() {
            if(typeof this.video === 'undefined' || typeof this.video.user === 'undefined')
                return false;

            return this.video.user.favored;
        }
    }
}
</script>

<style scoped>
    .card-img-top {
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }
</style>
